export default __webpack_public_path__ + "static/B0119-d0eda66d9558e81d32d2063e108d4501.png";